
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activities/activity-details",
      function () {
        return require("private-next-pages/activities/activity-details.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activities/activity-details"])
      });
    }
  